import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import trioLogo from '@/assets/trioLogo.png';
import Loading from '@/components/general/Loading';
import * as Styles from './SignIn.styles';

type SignInProps = {
  handleChangeInputs: (input: React.ChangeEvent<HTMLInputElement>) => void;
  handleLoginWithCredentials: () => void;
  handleGoogleLogin: () => void;
  handleRequestChangePassword: () => void;
  isLoading: boolean;
  errorMessage: string | null;
  temporaryMessageType: string;
};

const SignInPage = function ({
  handleChangeInputs,
  handleLoginWithCredentials,
  handleGoogleLogin,
  handleRequestChangePassword,
  isLoading,
  errorMessage,
  temporaryMessageType,
}: SignInProps): JSX.Element {
  return (
    <Styles.Grid>
      <Styles.ContentContainer>
        <Styles.Title>This is Zion</Styles.Title>
        <Styles.SubTitle>Here you&apos;ll find everything you need from Trio&reg;</Styles.SubTitle>

        <Styles.ContainerSocial>
          <Styles.Paragraph>Join our conversation on</Styles.Paragraph>
          <Styles.ContainerLinks>
            <a href="https://www.facebook.com/triodevelopers" target="_blank" rel="noreferrer">
              <FacebookIcon style={{ color: '#A8BFF2' }} />
            </a>
            <a href="https://twitter.com/usetrio" target="_blank" rel="noreferrer">
              <TwitterIcon style={{ color: '#A8BFF2' }} />
            </a>
            <a href="https://www.linkedin.com/company/triodev" target="_blank" rel="noreferrer">
              <LinkedInIcon style={{ color: '#A8BFF2' }} />
            </a>
          </Styles.ContainerLinks>
        </Styles.ContainerSocial>
      </Styles.ContentContainer>

      <Styles.SignInContainer>
        <Styles.Card>
          <Styles.Img src={trioLogo} alt="Trio's logo" />
          <Styles.FormTitle>Welcome</Styles.FormTitle>
          <Styles.Paragraph>Log in to continue to Zion.</Styles.Paragraph>

          {errorMessage && (
            <Styles.ErrorMessageBox type={temporaryMessageType}>
              {errorMessage}
            </Styles.ErrorMessageBox>
          )}

          <Styles.Form>
            <Styles.Input
              type="email"
              name="email"
              placeholder="Email address"
              onChange={handleChangeInputs}
              required
            />

            <Styles.Input
              type="password"
              name="password"
              placeholder="Password"
              onChange={handleChangeInputs}
              required
            />

            <Styles.ForgotPasswordLink onClick={handleRequestChangePassword}>
              Forgot password?
            </Styles.ForgotPasswordLink>
            <Styles.SignInBtn type="button" onClick={handleLoginWithCredentials}>
              {isLoading ? <Loading color="inherit" /> : <span>CONTINUE</span>}
            </Styles.SignInBtn>

          </Styles.Form>

          <Styles.SeparatorText>OR</Styles.SeparatorText>

          <Styles.GoogleBtn type="button" onClick={handleGoogleLogin}>
            <div>
              <GoogleIcon />
            </div>
            CONTINUE WITH GOOGLE
          </Styles.GoogleBtn>

          <Styles.LegalLinks>
            <a href="https://www.trio.dev/privacy-policy" target="_blank" rel="noreferrer">
              Privacy Policy
            </a>
            <span>·</span>
            <a href="https://www.trio.dev/terms-of-service" target="_blank" rel="noreferrer">
              Terms of Service
            </a>
          </Styles.LegalLinks>
        </Styles.Card>
      </Styles.SignInContainer>
    </Styles.Grid>
  );
};

export default SignInPage;
